import { ThirdwebClient } from "thirdweb";
import { ILogger } from "../../cityversetycoon/logger/ILogger";
import { Web3Config } from "../config/Web3Config";
import { WalletType } from "./WalletType";
import { InAppWallet } from "./wallets/InAppWallet";
import { IThirdWebWallet } from "./wallets/IThirdWebWallet";
import { PasskeyWallet } from "./wallets/PasskeyWallet";
import { ThirdWebAnalytic } from "../utils/ThirdWebAnalytic";

export class WalletFactory {
    private readonly wallets: Map<WalletType, IThirdWebWallet<any>>;

    public constructor(
        private readonly web3Config: Web3Config, 
        private readonly thirdWebclient: ThirdwebClient, 
        private readonly thirdWebAnalytic: ThirdWebAnalytic, 
        private readonly logger: ILogger
    ) {
        this.wallets = new Map();
    }

    public createWallet(walletType: WalletType): IThirdWebWallet<any> {
        if (this.wallets.has(walletType)) {
            return this.wallets.get(walletType);
        }

        switch (walletType) {
            case WalletType.EMAIL:
                const createdWallet = new InAppWallet(this.thirdWebclient, this.web3Config, this.thirdWebAnalytic, this.logger);
                this.wallets.set(walletType, createdWallet);
                return createdWallet;
            case WalletType.PASSKEY:
                const createdPasskeyWallet = new PasskeyWallet(this.thirdWebclient, this.web3Config, this.thirdWebAnalytic, this.logger);
                this.wallets.set(walletType, createdPasskeyWallet);
                return createdPasskeyWallet;
            default:
                throw new Error(`Unexpected wallet type: ${walletType}`);
        }
    }
}
